import { ChevronDownIcon } from '@chakra-ui/icons';
import { VStack, HStack, Box, useMediaQuery, useDisclosure } from '@chakra-ui/react';
import { Button } from 'Atoms';
import { Breadcrumbs } from 'Molecules/Breadcrumbs';
import { ViewSwitcher } from 'Molecules/ViewSwitcher';
import { StandardSwitcher } from '../ReportComponents/StandardSwitcher';
import { Menu } from 'Molecules/Menu';
import { EsrsReportStandardSwitch } from '../Report.types';
import { Loader } from 'Molecules';

enum ReportViews {
  prepare = 'Prepare',
  preview = 'Preview',
}

type ReportContainerProps = {
  reportDocGenerator: JSX.Element;
  canDownloadEsrsReport: boolean;
  standards: EsrsReportStandardSwitch[];
  structureLoading: boolean;
  answersLoading: boolean;
  sideMenu: React.ReactNode;
  reportContent: React.ReactNode;
  selectedView: string;
  setSelectedView: (view: string) => void;
  standardIndex: number;
  setStandardIndex: (index: number) => void;
};

const ReportContainer = ({
  reportDocGenerator,
  canDownloadEsrsReport,
  standards,
  structureLoading,
  answersLoading,
  sideMenu,
  reportContent,
  selectedView,
  setSelectedView,
  standardIndex,
  setStandardIndex,
}: ReportContainerProps) => {
  const [isSmall] = useMediaQuery('(max-width: 1600px)');
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <VStack w="100%" gap="0px" position="relative" overflow="hidden">
      <HStack
        w="100%"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="border.decorative"
        p="12px 16px"
        position="sticky"
        top="0"
        bg="bg.default"
        zIndex={2}
      >
        <Box w="30%">
          <Breadcrumbs noPadding />
        </Box>
        <StandardSwitcher
          standardIndex={standardIndex}
          isLoading={structureLoading}
          setStandardIndex={setStandardIndex}
          standards={standards}
        />
        <HStack w="30%" justifyContent="flex-end">
          <ViewSwitcher
            views={Object.values(ReportViews)}
            selected={selectedView}
            setSelected={setSelectedView}
          />
          <Menu
            size="lg"
            isOpen={isOpen}
            onClose={onClose}
            onOpen={onOpen}
            menuButton={
              <Button rightIcon={<ChevronDownIcon color="inherit" />} variant="primary">
                Download
              </Button>
            }
            sections={[
              {
                actions: [
                  {
                    id: 'esrs-report-word-doc',
                    render: () => (isOpen ? reportDocGenerator : <></>),
                    isDisabled: !canDownloadEsrsReport,
                    tooltipText: canDownloadEsrsReport ? '' : 'Contact us to enable this feature',
                  },
                ],
              },
            ]}
          />
        </HStack>
      </HStack>
      <HStack
        alignItems="start"
        gap="16px"
        justifyContent={isSmall ? 'flex-start' : 'center'}
        w="100%"
        paddingInline="16px"
        overflow="hidden"
        overflowX="auto"
      >
        {sideMenu}
        {answersLoading ? <Loader /> : reportContent}
        <Box minW="200px" h="100%"></Box>
      </HStack>
    </VStack>
  );
};

export default ReportContainer;
